import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { API_URL } from '../../../utils/constant';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetchSuppliers } from '../../../slices/company/supplierSlice';
import moment from 'moment';
import { customTableStyles } from '../../../utils/tableStylings';

const SupplierPayment = () => {
    const [data, setData] = useState([]);
    const { suppliers = [], loading, error } = useSelector((state) => state.suppliers);
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({
        vendor_id: '',
        vendor_name: '',
        payment: '',
        mode_of_payment: '',
        payment_details: '',
        payment_date: ''
    });

    const paymentModes = [
        { value: 'Cash', label: 'Cash', field: null },
        { value: 'Check', label: 'Check', field: 'Check Number' },
        { value: 'UPI', label: 'UPI', field: 'Transaction ID' },
        { value: 'Bank Transfer', label: 'Bank Transfer', field: 'Reference Number' },
        { value: 'Card', label: 'Card', field: 'Transaction ID' }
    ];

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            fetchData();
            dispatch(fetchSuppliers(company.company?.id));
        }

    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch(`${API_URL}/vendor-payments`);
            const result = await response.json();
            setData(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const selectedSupplier = suppliers.find(s => s.id == formData.vendor_id);
        const selectedMode = paymentModes.find(m => m.value === formData.mode_of_payment);
        let details = formData.payment_details;
        if (selectedMode && selectedMode.field) {
            details = `${selectedMode.field}: ${formData.payment_details}`;
        }
        const payload = {
            ...formData,
            vendor_name: selectedSupplier ? selectedSupplier.name : '',
            payment_details: details,
            payment_date: formData.payment_date
        };
        try {
            const url = editing ? `${API_URL}/vendor-payments/${editing.id}` : `${API_URL}/vendor-payments`;
            const method = editing ? 'PUT' : 'POST';
            const response = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                fetchData();
                setShowModal(false);
                resetForm();
            }
        } catch (error) {
            console.error('Error saving:', error);
        }
    };

    const handleEdit = (row) => {
        setEditing(row);
        const selectedMode = paymentModes.find(m => m.value === row.mode_of_payment);
        let details = row.payment_details;
        if (selectedMode && selectedMode.field && row.payment_details.startsWith(`${selectedMode.field}: `)) {
            details = row.payment_details.replace(`${selectedMode.field}: `, '');
        }
        setFormData({
            vendor_id: row.vendor_id,
            vendor_name: row.vendor_name,
            payment: row.payment,
            mode_of_payment: row.mode_of_payment,
            payment_details: details,
            payment_date: row.payment_date ? moment(row.payment_date).format('YYYY-MM-DDTHH:mm') : ''
        });
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure?')) {
            try {
                await fetch(`${API_URL}/vendor-payments/${id}`, { method: 'DELETE' });
                fetchData();
            } catch (error) {
                console.error('Error deleting:', error);
            }
        }
    };

    const resetForm = () => {
        setFormData({
            vendor_id: '',
            vendor_name: '',
            payment: '',
            mode_of_payment: '',
            payment_details: '',
            payment_date: ''
        });
        setEditing(null);
    };

    const columns = [
        {
            name: 'Vendor Name',
            selector: row => row.vendor_name,
            sortable: true
        },
        {
            name: 'Payment Made',
            selector: row => row.payment,
            sortable: true
        },
        {
            name: 'Mode of Payment',
            selector: row => row.mode_of_payment,
            sortable: true
        },
        {
            name: 'Mode of Payment',
            selector: row => row.mode_of_payment,
            sortable: true
        },
        {
            name: 'Payment Details',
            selector: row => row.payment_details,
            sortable: true
        },
        {
            name: 'Payment Date',
            selector: row => moment(row.payment_date).format('DD/MM/YYYY hh:mm A'),
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <div>
                    <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(row)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id)}>Delete</button>
                </div>
            )
        }
    ];

    return (
        <>
            <div className='card'>
                <div className='card-header  d-flex justify-content-between align-items-center gap-2'>
                    <h3 className="text-primary mb-0">Vendor Payments</h3>
                    <button className="btn btn-primary" onClick={() => { resetForm(); setShowModal(true); }}>Add Payment</button>
                </div>
                <div className='card-body'>
                    <DataTable
                        columns={columns}
                        data={data}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={customTableStyles}
                    />
                </div>
            </div>
            {showModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{editing ? 'Edit Payment' : 'Add Payment'}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Vendor</label>
                                        <select
                                            className="form-select"
                                            value={formData.vendor_id}
                                            onChange={(e) => setFormData({ ...formData, vendor_id: e.target.value })}
                                            required
                                        >
                                            <option value="">Select Vendor</option>
                                            {suppliers.map(supplier => (
                                                <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='mb-3'>
                                        <label className="form-label"> Payment Made</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={formData.payment}
                                            onChange={(e) => setFormData({ ...formData, payment: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Mode of Payment</label>
                                        <select
                                            className="form-select"
                                            value={formData.mode_of_payment}
                                            onChange={(e) => setFormData({ ...formData, mode_of_payment: e.target.value })}
                                            required
                                        >
                                            <option value="">Select Mode</option>
                                            {paymentModes.map(mode => (
                                                <option key={mode.value} value={mode.value}>{mode.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {paymentModes.find(m => m.value === formData.mode_of_payment)?.field && (
                                        <div className="mb-3">
                                            <label className="form-label">{paymentModes.find(m => m.value === formData.mode_of_payment).field}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.payment_details}
                                                onChange={(e) => setFormData({ ...formData, payment_details: e.target.value })}
                                                required
                                            />
                                        </div>
                                    )}
                                    <div className="mb-3">
                                        <label className="form-label">Payment Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            value={formData.payment_date}
                                            onChange={(e) => setFormData({ ...formData, payment_date: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {showModal && <div className="modal-backdrop show"></div>}
        </>
    );
};

export default SupplierPayment;
